module.exports = __webpack_public_path__ + "static/media/eatwell.2fa3f1d7.png";